import { render } from "./DataView.vue?vue&type=template&id=40103653&scoped=true"
import script from "./DataView.vue?vue&type=script&lang=js"
export * from "./DataView.vue?vue&type=script&lang=js"

import "./DataView.vue?vue&type=style&index=0&id=40103653&scoped=true&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40103653"]])

export default __exports__